export default __webpack_public_path__ + "static/media/commission.16c49592.svg";